import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { PalabraClaveActividadEconomica } from '../_models/palabra-clave-actividad-economica';
import { BusquedaFiltros } from '../_models/busqueda-filtros';
import { ActividadEconomica } from '../_models/actividad-economica';

@Injectable({
  providedIn: 'root'
})
export class PalabraClaveActividadEconomicaService {
  private rutServicio = AppSettings.rutServiciosRG + '/api/palabrasClavesActividadesEconomicas';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as PalabraClaveActividadEconomica[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as PalabraClaveActividadEconomica[] ) );
  }

  listadoPorPalabraClave( idPalabraClave: string ) {
    return this.httClient.get( this.rutServicio + '/palabraClave/' + idPalabraClave ).pipe( map( res => res as PalabraClaveActividadEconomica[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as PalabraClaveActividadEconomica ) );
  }

  crear( regCrear: PalabraClaveActividadEconomica ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as PalabraClaveActividadEconomica ) );
  }

  actualizar( regActualizar: PalabraClaveActividadEconomica ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }

  bulk( regActualizar: PalabraClaveActividadEconomica[] ) {
    regActualizar.map( ( s: PalabraClaveActividadEconomica ) => {
      s.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    } );
    return this.httClient.post( this.rutServicio + '/bulk', regActualizar ).pipe( map( res => res as any ) );
  }

  buscarAutocomplete( busqueda: BusquedaFiltros ) {
    return this.httClient.post( this.rutServicio + '/autocomplete', busqueda ).pipe( map( res => res as PalabraClaveActividadEconomica[] ) );
  }
}
